module.exports = "/_next/static/images/attorney-sahin-8f865ce18c346cf85c77113f8662bae8.png";